import React, { useState } from 'react';
import Navbar from './Navbar';
import style from './Technology.module.css';
import LaunchVehicleLand from './technology/image-launch-vehicle-landscape.jpg';
import SpaceportLand from './technology/image-spaceport-landscape.jpg';
import SpaceCapsuleLand from './technology/image-space-capsule-landscape.jpg';
import LaunchVehiclePotrait from './technology/image-launch-vehicle-portrait.jpg';
import SpaceportPotrait from './technology/image-spaceport-portrait.jpg';
import SpaceCapsulePotrait from './technology/image-space-capsule-portrait.jpg';

const Technology = () => {
  const [selectedTech, setSelectedTech] = useState(0);

  const technology = [
    {
      name: 'Launch vehicle',
      images: {
        landscape: LaunchVehicleLand,
        portrait: LaunchVehiclePotrait,
      },
      description:
        'A launch vehicle or carrier rocket is a rocket-propelled vehicle used to carry a payload from Earth\'s surface to space, usually to Earth orbit or beyond. Our WEB-X carrier rocket is the most powerful in operation. Standing 150 metres tall, it\'s quite an awe-inspiring sight on the launch pad!',
    },
    {
      name: 'Spaceport',
      images: {
        landscape: SpaceportLand,
        portrait: SpaceportPotrait,
      },
      description:
        'A spaceport or cosmodrome is a site for launching (or receiving) spacecraft, by analogy to the seaport for ships or airport for aircraft. Based in the famous Cape Canaveral, our spaceport is ideally situated to take advantage of the Earth’s rotation for launch.',
    },
    {
      name: 'Space capsule',
      images: {
        landscape: SpaceCapsuleLand,
        portrait: SpaceCapsulePotrait,
      },
      description:
        'A space capsule is an often-crewed spacecraft that uses a blunt-body reentry capsule to reenter the Earth\'s atmosphere without wings. Our capsule is where you\'ll spend your time during the flight. It includes a space gym, cinema, and plenty of other activities to keep you entertained.',
    },
  ];

  return (
    <div className={style.Technology}>
      <Navbar />
      <main className={style.mainTechnology}>
        <h1>
          <span>03</span> SPACE LAUNCH 101
        </h1>
        <div className={style.TechDetails}>
          {/* Technology Info */}
          <div className={style.TechInfo}>
            <div className={style.tabNumbers}>
              {technology.map((tech, index) => (
                <button
                  key={tech.name}
                  className={index === selectedTech ? style.activeTabTech : style.tabTech}
                  onClick={() => setSelectedTech(index)}
                >
                  {index + 1}
                </button>
              ))}
            </div>
            <div className={style.techContent}>
              <h3>THE TERMINOLOGY...</h3>
              <h2>{technology[selectedTech].name}</h2>
              <p className={style.description}>{technology[selectedTech].description}</p>
            </div>
          </div>
          {/* Technology Image */}
          <div>
            <picture>
              <source media="(min-width: 768px)" srcSet={technology[selectedTech].images.portrait} />
              <img
                className={style.techImg}
                src={technology[selectedTech].images.landscape}
                alt={technology[selectedTech].name}
              />
            </picture>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Technology;
